module.exports = __webpack_public_path__ + "static/media/vishnumayaunni.c44bd9fe.jpeg";